import { Styles } from "jss";
import { Theme } from "../../utils/theme";

export const styles = (theme: Theme): Styles => ({
  root: {
    boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
    background: theme.backgroundColor_90 as string,
    borderRadius: 8,
    display: "inline-block",
    position: "relative",
    padding: 24,
    paddingBottom: 24,
    margin: 16,
    zIndex: 0,
    verticalAlign: 'top',
  }
});
